import gql from 'graphql-tag'

export const GetUsuarioLogadoQueryName = 'GetUsuarioLogadoQuery'

export const usuarioLogadoQueryGql = gql`
  query GetUsuarioLogadoQuery {
    usuarioLogado {
      id
      nome
      avatarLink
      marcas {
        id
        description
        facebookId
      }
      tipo {
        id
      }
      idioma {
        id
      }
      funcionalidades {
        id
        chave
      }
      gruposUsuarios {
        id
        nome
      }
      dadosComplementares {
        id
        descricao
        ordem
        urlBase
        tipo
        funcionalidades {
          produto {
            id
            nome
          }
        }
      }
    }
  }
`
